/* Aimer Joias — seletor de variações de pedra e banho (produtos-irmãos).
   Progressive enhancement: sem este arquivo a grade continua completa e clicável. */
(function () {
  'use strict';

  var podeHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  var economiaDados = !!(navigator.connection && navigator.connection.saveData);
  var prefetchados = {};

  function prefetch(url) {
    if (!url || economiaDados || prefetchados[url]) return;
    prefetchados[url] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }

  /* A imagem grande da prévia é a própria miniatura com outro width no CDN. */
  function imagemGrande(item) {
    var img = item.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    return src ? src.replace(/([?&]width=)\d+/, '$1900') : null;
  }

  function alvoDaGaleria() {
    var seletores = [
      '.product__media-wrapper .product__media-item.is-active .product__media',
      '.product__media-wrapper .product__media',
      '.product__media-list .product__media',
      '.product__media-gallery .product__media'
    ];
    for (var i = 0; i < seletores.length; i++) {
      var el = document.querySelector(seletores[i]);
      if (el) return el;
    }
    return null;
  }

  class ElementoVariacoes extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;

      this.grade = this.querySelector('[data-var-grade]');
      this.celulas = Array.prototype.slice.call(this.querySelectorAll('.aimer-var__celula'));
      this.itens = Array.prototype.slice.call(this.querySelectorAll('[data-var-item]'));
      this.legenda = this.querySelector('[data-var-legenda]');
      this.legendaOriginal = this.legenda ? this.legenda.innerHTML : '';

      this.ligarPilulas();
      this.ligarPrevia();
      this.ligarTeclado();
    }

    ligarPilulas() {
      var caixa = this.querySelector('[data-var-banhos]');
      if (!caixa) return;
      caixa.hidden = false;
      var self = this;
      var pilulas = Array.prototype.slice.call(caixa.querySelectorAll('[data-var-filtro]'));

      pilulas.forEach(function (pilula) {
        pilula.addEventListener('click', function () {
          var filtro = pilula.getAttribute('data-var-filtro');
          pilulas.forEach(function (p) {
            var ativa = p === pilula;
            p.classList.toggle('is-ativa', ativa);
            p.setAttribute('aria-pressed', ativa ? 'true' : 'false');
          });
          self.celulas.forEach(function (celula) {
            var banho = celula.getAttribute('data-var-banho') || '';
            var mostra = filtro === '__todos' || banho === filtro || banho === '';
            celula.classList.toggle('is-oculta', !mostra);
          });
        });
      });
    }

    ligarPrevia() {
      var self = this;
      var alvo = podeHover ? alvoDaGaleria() : null;
      var previa = null;

      if (alvo) {
        if (getComputedStyle(alvo).position === 'static') alvo.style.position = 'relative';
        previa = document.createElement('img');
        previa.className = 'aimer-var__previa';
        previa.alt = '';
        previa.setAttribute('aria-hidden', 'true');
        previa.loading = 'lazy';
        previa.decoding = 'async';
        alvo.appendChild(previa);
      }

      function mostrar(item) {
        prefetch(item.getAttribute('href'));
        if (self.legenda) {
          var nome = item.getAttribute('data-var-nome') || '';
          var banho = item.getAttribute('data-var-banho-rotulo') || '';
          var preco = item.getAttribute('data-var-preco') || '';
          var texto = nome + (banho ? ' · ' + banho : '') + (preco ? ' — ' + preco : '');
          if (item.hasAttribute('data-var-esgotada')) texto += ' (esgotado)';
          self.legenda.textContent = texto;
        }
        var grande = imagemGrande(item);
        if (previa && grande) {
          previa.src = grande;
          previa.classList.add('is-visivel');
        }
      }

      function esconder() {
        if (self.legenda) self.legenda.innerHTML = self.legendaOriginal;
        if (previa) previa.classList.remove('is-visivel');
      }

      this.itens.forEach(function (item) {
        item.addEventListener('mouseenter', function () { mostrar(item); });
        item.addEventListener('mouseleave', esconder);
        item.addEventListener('focus', function () { mostrar(item); });
        item.addEventListener('blur', esconder);
        item.addEventListener('touchstart', function () {
          prefetch(item.getAttribute('href'));
        }, { passive: true });
      });
    }

    ligarTeclado() {
      var self = this;
      if (!this.grade) return;
      this.grade.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var visiveis = self.itens.filter(function (i) {
          return !i.closest('.aimer-var__celula').classList.contains('is-oculta');
        });
        var atual = visiveis.indexOf(document.activeElement);
        if (atual === -1) return;
        e.preventDefault();
        var proximo = e.key === 'ArrowRight' ? atual + 1 : atual - 1;
        if (proximo < 0) proximo = visiveis.length - 1;
        if (proximo >= visiveis.length) proximo = 0;
        visiveis[proximo].focus();
      });
    }
  }

  if (!customElements.get('aimer-variacoes')) {
    customElements.define('aimer-variacoes', ElementoVariacoes);
  }
})();
